export default "/images/instagram.svg?de29e48fcd676cd9e35e2df50685605b";